<template>
  <div class="label-template-edit">
    <div class="label-template-scroll">
    <!-- 标题条（questionnaireAdd 同款框架：返回按钮左上、标题居中） -->
    <div class="title-box">
      <el-button type="default" size="small" @click="goBack">返回</el-button>
      <span>{{ form.guid ? "编辑标注标签" : "新增标注标签" }}</span>
    </div>

    <!-- 基础信息 -->
    <div class="base">
      <div class="title" @click="isExpandBase = !isExpandBase">
        <div class="title-config">
          <i :class="isExpandBase ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
          基础信息
        </div>
      </div>
      <div v-show="isExpandBase" class="base-body">
      <el-form :model="form" label-width="170px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="数据模态" required>
            <el-select v-model="form.dataModalGuid" placeholder="请选择" class="w100f" @change="onDataModalChange">
              <el-option v-for="item in dataModalOptions" :key="item.guid" :label="item.text" :value="item.guid"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检查类型或解剖部位" required>
            <el-select v-model="form.examTypeGuid" placeholder="请选择" class="w100f" @change="onExamTypeChange">
              <el-option v-for="item in examTypeOptions" :key="item.guid" :label="item.text" :value="item.guid"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否属性设置" required>
            <el-radio-group v-model="form.hasAttr" @change="onHasAttrChange">
              <el-radio label="N">否</el-radio>
              <el-radio label="Y">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="启用状态" required>
            <el-switch v-model="form.enableState" active-value="Y" inactive-value="N"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="病灶或疾病实体" required>
            <el-input v-model="form.labelName" maxlength="256" placeholder="请输入" class="w100f"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="标签名称" required>
            <!-- 标签名称支持最多 300 个，每个最多 20 字 -->
            <!-- 2026-10-09 存储形态改造：标签名称改竖线合并落库，单项不能含竖线（forbid-chars 拦截），中英文逗号自由输入 -->
            <!-- 2026-10-08 样式反馈：标签名称另起一行独占两列宽度（原 span=12 右列，长标签串被挤压） -->
            <tag-input v-if="form.hasAttr !== 'Y'" v-model="form.templateNameList" batch :max-length="20" :max="300" word="标签名称" :forbid-chars="['|']" forbid-name="竖线" @pending-change="pendingNameInput = $event.pending"></tag-input>
            <el-input v-else v-model="form.templateName" maxlength="100" placeholder="请输入" class="w100f"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      </el-form>
      </div>
    </div>

    <!-- 标签属性（医生标注时填写项） -->
    <template v-if="form.hasAttr === 'Y'">
      <div class="base">
        <div class="title" @click="isExpandAttr = !isExpandAttr">
          <div class="title-config">
            <i :class="isExpandAttr ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
            标签属性（医生标注时填写项）
          </div>
          <el-button type="primary" size="mini" class="add-attr-btn" @click.stop="addAttr">+ 新增属性</el-button>
        </div>
        <div v-show="isExpandAttr" class="base-body">
        <!-- 2026-10-08 样式反馈：attr-table 对齐系统列表样式（表头灰底/32px/边线/文字色），见 scoped 内说明 -->
        <el-table :data="form.attrList" border class="attr-table">
        <el-table-column label="属性名称" min-width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.attrName" placeholder="必填"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="控件类型" width="130">
          <template slot-scope="scope">
            <el-select v-model="scope.row.controlType" placeholder="必选" @change="onControlTypeChange(scope.row)">
              <el-option label="数值" value="NUMBER"></el-option>
              <el-option label="单选" value="RADIO"></el-option>
              <el-option label="多选" value="CHECKBOX"></el-option>
              <el-option label="文本" value="TEXT"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="取值范围 / 可选项" min-width="260">
          <template slot-scope="scope">
            <!-- 2026-10-09 交互优化：单选/多选可选项改 TagInput 逐项回车添加（免手打分隔符，
                 选项边界一目了然）；数值/文本保持文本输入。落库走 options 数组（后端 JSON 化存 value_range） -->
            <tag-input
              v-if="['RADIO', 'CHECKBOX'].includes(scope.row.controlType)"
              v-model="scope.row.optionsList"
              batch
              word="选项"
              :max-length="50"
              :max="20"
              @pending-change="setOptionInputPending(scope.row, $event)"
            ></tag-input>
            <el-input
              v-else
              v-model="scope.row.valueRange"
              :placeholder="rangePlaceholder(scope.row.controlType)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="必填" width="100">
          <template slot-scope="scope">
            <el-select v-model="scope.row.isRequired">
              <el-option label="必填" value="Y"></el-option>
              <el-option label="选填" value="N"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="text" class="danger" @click="removeAttr(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
        </div>
      </div>

      <!-- 医生端属性填写面板预览 -->
      <div class="base">
        <div class="title" @click="isExpandPreview = !isExpandPreview">
          <div class="title-config">
            <i :class="isExpandPreview ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
            医生端属性填写面板预览
          </div>
        </div>
        <div v-show="isExpandPreview" class="base-body">
        <div class="preview-panel">
        <div v-for="(attr, index) in form.attrList" :key="index" class="preview-item">
          <span class="preview-label">
            {{ attr.attrName }}<span v-if="attr.isRequired === 'Y'" class="required-mark">*</span>
          </span>
          <el-input
            v-if="attr.controlType === 'NUMBER'"
            placeholder="数值"
            class="preview-number"
            disabled
          ></el-input>
          <el-input
            v-else-if="attr.controlType === 'TEXT'"
            type="textarea"
            :rows="2"
            placeholder="文本"
            disabled
          ></el-input>
          <div v-else class="preview-pills">
            <span
              v-for="opt in optionsOf(attr)"
              :key="opt"
              :class="['pill', attr.controlType === 'CHECKBOX' ? 'multi' : 'single']"
            >
              {{ opt }}
            </span>
            <span v-if="!optionsOf(attr).length" class="pill empty">未设置可选项</span>
          </div>
        </div>
        <div v-if="!form.attrList.length" class="empty">暂无属性，请先新增属性</div>
        </div>
      </div>
    </div>
    </template>

    </div>
    <!-- 保存栏占用独立空间，避免遮挡表单 -->
    <div class="back-color-fff submit_btn_wrap">
      <el-button type="primary" :loading="submitting" @click="onSave">保存</el-button>
    </div>
  </div>
</template>

<script>
import TagInput from "./components/TagInput.vue";

export default {
  name: "labelTemplateEdit",
  components: { TagInput },
  data() {
    return {
      // 区块折叠状态（questionnaireAdd 同款可折叠卡片框架）
      isExpandBase: true,
      isExpandAttr: true,
      isExpandPreview: true,
      dataModalOptions: [],
      examTypeOptions: [],
      submitting: false,
      pendingNameInput: false,
      pendingOptionInputs: new Map(),
      form: {
        guid: "",
        tenantGuid: localStorage.guid,
        dataModalGuid: "",
        dataModalName: "",
        examTypeGuid: "",
        examTypeName: "",
        templateName: "",
        // 新增模式下的标签名称（多标签）
        templateNameList: [],
        labelName: "",
        hasAttr: "N",
        enableState: "Y",
        attrList: [],
      },
    };
  },
  created() {
    this.initDict();
    if (this.$route.query.guid) {
      this.getEditDetail(this.$route.query.guid);
    }
  },
  methods: {
    setOptionInputPending(row, state) {
      if (state.pending) {
        if (!this.pendingOptionInputs.has(state.input)) {
          this.pendingOptionInputs.set(state.input, { row, controlType: row.controlType });
        }
      } else {
        this.pendingOptionInputs.delete(state.input);
      }
    },
    initDict() {
      this.api
        .get(`/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=数据模态`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.dataModalOptions = res.data.data || [];
          }
        });
      this.api
        .get(`/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=检查类型或解剖部位`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.examTypeOptions = res.data.data || [];
          }
        });
    },
    getEditDetail(guid) {
      this.api
        .get(`/${serverConfig.msSalesPerformService}/label-template/edit-detail?guid=${guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE && res.data.data) {
            // 后端无值字段为 null，不兜底会覆盖 data() 的 [] 致后续 .length 抛错；
            // templateNameList 由后端按存储形态条件拆返回（含 | 按竖线、旧数据按英文逗号，兼容收敛在后端一处）；
            // 可选项直接取后端 attrList[].options 数组（旧串形态兼容拆同样在后端回显处），前端只持数组形态
            this.form = {
              ...this.form,
              ...res.data.data,
              attrList: (res.data.data.attrList || []).map((a) => ({ ...a, optionsList: a.options || [] })),
              templateNameList: res.data.data.templateNameList || [],
            };
          }
        });
    },
    onDataModalChange(guid) {
      const hit = this.dataModalOptions.find((item) => item.guid === guid);
      this.form.dataModalName = hit ? hit.text : "";
    },
    onExamTypeChange(guid) {
      const hit = this.examTypeOptions.find((item) => item.guid === guid);
      this.form.examTypeName = hit ? hit.text : "";
    },
    onHasAttrChange(val) {
      if ((val === "Y" && this.pendingNameInput) || (val === "N" && this.pendingOptionInputs.size)) {
        this.form.hasAttr = val === "Y" ? "N" : "Y";
        this.$message.warning("请先更正或清空未完成的标签输入");
        return;
      }
      // 新增/编辑同联动：标签名称控件随 hasAttr 切换（TagInput ↔ 单输入框），值双向搬运
      if (val === "Y") {
        // 切为“是”：多标签列表重置，首值带入单输入框，避免脏数据。
        // 单值必须无条件重置为列表首项——编辑态回显的 templateName 是后端竖线合并串（非空），
        // 若沿用“仅空值才带入”的旧条件，合并串会裸显在单输入框，且保存被“不能包含竖线”拦截
        this.form.templateName = this.form.templateNameList.length ? this.form.templateNameList[0] : "";
        this.form.templateNameList = [];
        // 切为“是”默认带一行空属性（FOUR-2976），避免用户还要找新增入口
        if (!this.form.attrList.length) {
          this.addAttr();
        }
        return;
      }
      // 切回“否”：确认通过后属性重置、单值重置并转入多标签
      const applySwitch = () => {
        if (!this.form.templateNameList.length && this.form.templateName && this.form.templateName.trim()) {
          this.form.templateNameList = [this.form.templateName.trim()];
        }
        this.form.templateName = "";
        this.form.attrList = [];
      };
      if (this.form.attrList.length) {
        this.$confirm("切换为不设置属性将清空已配置的属性和已填的标签名称，确定吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => applySwitch(), () => {
            // 仅取消才还原；applySwitch 自身异常不得伪装成取消（此前链式 catch 把确定也还原了）
            this.form.hasAttr = "Y";
          });
      } else {
        applySwitch();
      }
    },
    rangePlaceholder(controlType) {
      // 单选/多选已改 TagInput 逐项添加（2026-10-09 交互优化），此处只服务数值/文本
      return {
        NUMBER: "如：1 - 100 mm（步长 0.1）",
        TEXT: "如：≤ 200 字",
      }[controlType] || "请输入";
    },
    // 预览区选项来源：TagInput 维护的 options 数组（旧串形态兼容拆收敛在后端回显一处，前端不再兜底拆）
    optionsOf(attr) {
      return attr.optionsList || [];
    },
    addAttr() {
      if (this.pendingOptionInputs.size) {
        this.$message.warning("请先更正或清空未完成的属性选项输入");
        return;
      }
      // 新行插首行（FOUR-2976 方案A）：按钮在列表右上角，点击后新行落在按钮正下方无需滚动
      this.form.attrList.unshift({
        attrName: "",
        controlType: "RADIO",
        valueRange: "",
        optionsList: [],
        isRequired: "N",
      });
    },
    // 控件类型切换：取值范围/可选项语义随类型互斥，清掉另一态残留——
    // 选项类行切数值/文本时清 valueRange（后端回显为 options 派生的英文逗号串、旧快照为逗号合并串，
    // 均非范围描述语义，不清会灌入输入框随保存落库）；数值↔文本同属文本语义，互切不清已填内容
    onControlTypeChange(row) {
      const pendingInput = Array.from(this.pendingOptionInputs.values()).find((item) => item.row === row);
      if (pendingInput) {
        row.controlType = pendingInput.controlType;
        this.$message.warning("请先更正或清空未完成的属性选项输入");
        return;
      }
      if (["RADIO", "CHECKBOX"].includes(row.controlType)) {
        row.valueRange = "";
      } else if ((row.optionsList || []).length) {
        row.optionsList = [];
        row.valueRange = "";
      }
    },
    // 删除属性行：已配置内容（属性名/可选项/取值范围任一非空）先弹框确认，空行直接删
    removeAttr(index) {
      if (this.pendingOptionInputs.size) {
        this.$message.warning("请先更正或清空未完成的属性选项输入");
        return;
      }
      const attr = this.form.attrList[index];
      const hasContent =
        (attr.attrName && attr.attrName.trim()) ||
        (attr.optionsList || []).length ||
        (attr.valueRange && attr.valueRange.trim());
      const doRemove = () => this.form.attrList.splice(index, 1);
      if (!hasContent) {
        doRemove();
        return;
      }
      this.$confirm("该属性已配置内容，确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(doRemove, () => {});
    },
    checkForm() {
      if (!this.form.dataModalGuid) return "请选择数据模态";
      if (!this.form.examTypeGuid) return "请选择检查类型或解剖部位";
      // 标签名称：设属性时为单输入框；不设属性时为多标签（新增/编辑同联动）。
      // 多标签合并存一条（竖线，由后端 join 落库；前端拦竖线输入），编辑多标签合法，不再限单标签
      if (this.form.hasAttr === "Y") {
        if (!this.form.templateName || !this.form.templateName.trim()) return "请输入标签名称";
      } else {
        if (!this.form.templateNameList.length) return "请添加标签名称";
      }
      if (!this.form.labelName || !this.form.labelName.trim()) return "请输入病灶或疾病实体";
      if (this.form.hasAttr === "Y") {
        if (!this.form.attrList.length) return "设置属性时至少新增一条属性";
        const attrNames = new Set();
        for (const attr of this.form.attrList) {
          if (!attr.attrName) return "属性名称必填";
          if (attrNames.has(attr.attrName.trim())) return `属性名称不能重复：${attr.attrName.trim()}`;
          attrNames.add(attr.attrName.trim());
          if (!attr.controlType) return "属性控件类型必选";
          if (["RADIO", "CHECKBOX"].includes(attr.controlType) && !(attr.optionsList || []).length)
            return "单选/多选属性必须设置可选项";
        }
      }
      return "";
    },
    onSave() {
      if (this.form.hasAttr !== "Y" && this.pendingNameInput) {
        this.$message.error("请先更正或清空未完成的标签名称输入");
        return;
      }
      if (this.form.hasAttr === "Y" && this.pendingOptionInputs.size) {
        this.$message.error("请先更正或清空未完成的属性选项输入");
        return;
      }
      const errMsg = this.checkForm();
      if (errMsg) {
        this.$message.error(errMsg);
        return;
      }
      // 落库契约：单选/多选传 options 数组（后端 JSON 化存 value_range），数值/文本传 valueRange 文本；
      // optionsList 为纯前端字段须剔除，两态互不掺带（控件类型切换时 onControlTypeChange 已清另一态残留）
      const payload = {
        ...this.form,
        attrList: (this.form.attrList || []).map((attr) => {
          const { optionsList, options, valueRange, ...rest } = attr;
          return ["RADIO", "CHECKBOX"].includes(attr.controlType)
            ? { ...rest, options: optionsList || [] }
            : { ...rest, valueRange: valueRange || "" };
        }),
      };
      this.submitting = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/label-template/save`, payload)
        .then((res) => {
          this.submitting = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success("保存成功");
            this.goBack();
          } else {
            this.$message.error(res.data.msg || "保存失败");
          }
        })
        .catch(() => {
          this.submitting = false;
        });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
/* 标题条（questionnaireAdd 同款：返回按钮左上、标题居中） */
.title-box {
  border-top: 1px solid #e5e5e5;
  background-color: #ffffff;
  padding: 8px 0px;
  position: relative;
  margin-bottom: 4px;
  text-align: center;
}
.title-box button {
  font-size: 12px;
  color: #212121;
  letter-spacing: 0;
  width: 60px;
  height: 26px;
  padding: 0px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  position: absolute;
  left: 16px;
  top: 6px;
}
.title-box span {
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  color: #212121;
}
/* 可折叠卡片区块（questionnaireAdd 同款框架） */
.base {
  background: #fff;
  border: 1px solid #d9d9d9;
  margin-bottom: 4px;
  text-align: left;
}
.base > .title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  border-bottom: 1px solid #ebeef5;
  background-color: #fafafa;
  cursor: pointer;
}
.title-config i {
  margin-right: 8px;
  color: #606266;
}
.base-body {
  padding: 16px 20px;
}
.add-attr-btn {
  margin-left: 12px;
}
.w100f {
  width: 100%;
}
.danger {
  color: #f56c6c;
}
/* 2026-10-08 样式反馈：属性表格对齐系统列表样式。
   列表页标准样式挂在 .content-main-box 作用域（style.css:415-446），本页表格裸在 .base-body 吃不到；
   不能直接套该类（自带 calc(100vh) 固定高度会破坏编辑页布局），故 scoped 复刻：
   表头 #F2F2F2 灰底 + 32px + #D9D9D9 边线、字号 12px、文字 #212121。
   行内为输入控件（高 40px），cell 不照搬 padding:0/行高 32，改紧凑 4px 8px 保持观感一致且不裁控件 */
.attr-table {
  font-size: 12px;
  color: #212121;
}
.attr-table /deep/ th.el-table__cell {
  background-color: #f2f2f2;
  height: 32px;
  padding: 0 8px;
  border-right: 1px solid #d9d9d9;
  border-top: 1px solid #d9d9d9;
  color: #212121;
  font-weight: 500;
}
.attr-table /deep/ td.el-table__cell {
  padding: 4px 8px;
  border-bottom: 1px solid #d9d9d9;
}
.preview-panel {
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  padding: 16px;
  background: #fafafa;
}
.preview-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}
.preview-label {
  width: 120px;
  /* 2026-10-09：flex 行内选项多时 label 被压缩（实测 120→99px），禁缩保固定宽 */
  flex-shrink: 0;
  line-height: 32px;
  color: #606266;
}
.required-mark {
  color: #f56c6c;
}
.preview-number {
  width: 200px;
}
.preview-pills {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.pill {
  padding: 4px 16px;
  border: 1px solid #dcdfe6;
  border-radius: 16px;
  color: #606266;
  background: #fff;
}
.pill.empty {
  color: #c0c4cc;
}
.empty {
  color: #909399;
}
.label-template-edit {
  display: flex;
  flex-direction: column;
  height: min(calc(100vh - 88px), calc(100% - 35px));
  min-height: 0;
}
.label-template-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.label-template-edit > .submit_btn_wrap {
  position: static;
  flex: 0 0 60px;
  box-sizing: border-box;
  width: 100%;
}
</style>
